/**
 * Singleton provider class
 */
export default class Provider {
  providerInstance = null;
  schema = null;
  token = null;
  sessionKey = null;

  /**
   * @returns {Provider}
   */
  static getInstance() {
    if (Provider.providerInstance == null) {
      Provider.providerInstance = new Provider();
    }
    return this.providerInstance;
  }

  setSchema(schema) {
    this.schema = schema;
  }

  getSchema() {
    return this.schema;
  }

  setToken(token) {
    this.token = token;
  }

  getToken() {
    return this.token;
  }
  setSessionKey(sessionKey) {
    this.sessionKey = sessionKey;
  }

  getSessionKey() {
    return this.sessionKey;
  }
  setTimeZone(time_zone) {
    this.time_zone = time_zone;
  }

  getTimeZone() {
    return this.time_zone;
  }
}
